import React, { Component } from "react";
import { Button, PageHeader, DropdownButton } from "react-bootstrap";
import { invokeSetSaveMultipleExercises } from "../../utils/AwsInvoke";
import KeywordsInput              from "../../components/exercise/KeywordsInput";
import DropdownExerciseCategories from "../../components/exercise/DropdownExerciseCategories";
import ExerciseCategories         from "../../utils/ExerciseCategories";
import LoaderButton               from "../../components/LoaderButton";
import YouTubePlayer              from "../../components/YouTubePlayer";
import AddExercisePanel           from "../../components/exercise/AddExercisePanel";
import FooterLoadingBar           from "../../components/utils/FooterLoadingBar";
import uniqueId                   from 'lodash/uniqueId';
import "../../css/exercise/ExerciseNewMultiple.css";

var _global_exercise_name_arr = [];
var _global_yt_id_arr         = [];
var _global_cat_id_arr        = [];
var _global_keywords_arr      = [];
var _global_start_arr         = [];
var _global_execute_arr       = [];
var _global_focus_arr         = [];
var _global_goal_arr          = [];
var _global_pub_arr           = [];
//var _global_youtube_id        = "";

export default class ExerciseNewMultiple extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          exercise_name_arr: [],
          showLoadingBar: "none"
        };
    }

    componentWillUnmount() {
        if (this.props.history.action === "POP") {
            // custom back button implementation
        }
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
        } catch (e) {
            alert(e);
        }
    }

    handleProgramClick = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderLander() {
        return (
          <div className="lander">
            <h1>Training Slate</h1>
            <p>An app to help create training programs</p>
          </div>
        );
    }

    renderHome() {
        return (
          <div className="programs">
                <PageHeader>
                        { /*}<span style={{fontSize:"16px"}}>exercise list > </span>*/ } Add Multiple Exercises
                </PageHeader>

                { this.listExercises() }

                <br/><br/><br/><br/><br/>
                <div className="multipleExerciseFooter">
                    <span className="multipleExerciseFooterSaveAllBtn"
                          onClick={() => this.saveAllExercises()}>
                        Save Exercises
                    </span>
                </div>
          </div>
        );
    }

    listExercises = () => {
        var panel = [];
        var listExercises;

        for(var i = 0; i< 25; i++) {
             panel.push(<AddExercisePanel
                            key={uniqueId()}
                            ctr={i+1}
                            setExerciseName = {this.setExerciseName}
                            setYouTubeId    = {this.setYouTubeId}
                            setCategoryId   = {this.setCategoryId}
                            setKeywords     = {this.setKeywords}
                            setStartText    = {this.setStartText}
                            setExecuteText  = {this.setExecuteText}
                            setFocusText    = {this.setFocusText}
                            setGoalText     = {this.setGoalText}
                            setPubText      = {this.setPubText}
                            goToExerciselist= {this.goToExerciselist}
                        />)
        }

        return panel;
    }

    goToExerciselist = () => {
        this.props.history.push("/exercise/listAll/&");
    }

    setExerciseName = (id, name) => {
        id = id-1; // start at 0 element
        _global_exercise_name_arr[id] = name;
    }

    setYouTubeId = (id, yt_id) => {
        id = id-1; // start at 0 element
        _global_yt_id_arr[id] = yt_id;
    }

    setCategoryId = (id, cat_id) => {
        id = id-1; // start at 0 element
        _global_cat_id_arr[id] = cat_id;
    }

    setKeywords = (id, keyword) => {
        id = id-1; // start at 0 element
        _global_keywords_arr[id] = keyword;
    }

    setStartText = (id, start) => {
        id = id-1; // start at 0 element
        _global_start_arr[id] = start;
    }

    setExecuteText = (id, execute) => {
        id = id-1; // start at 0 element
        _global_execute_arr[id] = execute;
    }

    setFocusText = (id, focus) => {
        id = id-1; // start at 0 element
        _global_focus_arr[id] = focus;
    }

    setGoalText = (id, goal) => {
        id = id-1; // start at 0 element
        _global_goal_arr[id] = goal;
    }

    setPubText = (id, pub) => {
        id = id-1; // start at 0 element

        _global_pub_arr[id] = pub;
    }

    saveAllExercises = () => {
        var new_arr = [];
        this.setState({
            showLoadingBar: "inline"
        })
        for(var i=0; i < _global_exercise_name_arr.length; i++) {
            var tmp_name = _global_exercise_name_arr[i];

            if(tmp_name != undefined) {
                var tmp_yt_id   = _global_yt_id_arr[i];
                var tmp_cat_id  = _global_cat_id_arr[i];
                var tmp_keyword = _global_keywords_arr[i];
                var tmp_start   = _global_start_arr[i];
                var tmp_execute = _global_execute_arr[i];
                var tmp_focus   = _global_focus_arr[i];
                var tmp_goal    = _global_goal_arr[i];
                var tmp_pub     = _global_pub_arr[i];

                new_arr.push([tmp_name, tmp_yt_id, tmp_cat_id, tmp_keyword, tmp_start, tmp_execute, tmp_focus, tmp_goal, tmp_pub])
            }
        }

        this.setSaveMultipleExercises(new_arr);
    }

    setSaveMultipleExercises = async (new_arr) => {

        var exerc_id_arr = [];
        var name_arr     = [];
        var youtube_arr  = [];
        var pub_arr      = [];
        var start_arr    = [];
        var execute_arr  = [];
        var focus_arr    = [];
        var goal_arr     = [];
        var category_ids_arr = [];
        var keywords_arr     = [];
        const uuidv1 = require('uuid/v1');

        for(var i=0; i < new_arr.length; i++) {
            var tmp_name    = new_arr[i][0];
            var tmp_yt_id   = new_arr[i][1];
            var tmp_cat_id  = new_arr[i][2];
            var tmp_keyword = new_arr[i][3];
            var tmp_start   = new_arr[i][4];
            var tmp_execute = new_arr[i][5];
            var tmp_focus   = new_arr[i][6];
            var tmp_goal    = new_arr[i][7];
            var tmp_pub     = new_arr[i][8];

            exerc_id_arr.push(uuidv1());
            name_arr.push(tmp_name)
            youtube_arr.push(tmp_yt_id)
            start_arr.push(tmp_start)
            execute_arr.push(tmp_execute)
            focus_arr.push(tmp_focus)
            goal_arr.push(tmp_goal)
            category_ids_arr.push(tmp_cat_id)
            keywords_arr.push(tmp_keyword)
            pub_arr.push(tmp_pub)
        }

        const results = await invokeSetSaveMultipleExercises(exerc_id_arr, name_arr, youtube_arr, pub_arr, start_arr, execute_arr, focus_arr, goal_arr, category_ids_arr, keywords_arr);

        if(results) {
            this.hideLoadingBar();
            // Go Back to Exercise List
            this.props.history.push("/exercise/listAll/&");
        } else
            this.hideLoadingBar();
    }

    hideLoadingBar = () => {
        this.setState({
            showLoadingBar: "none"
        })
    }

    render() {

        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : this.renderLander()}

                <FooterLoadingBar text={"Saving Exercise Data..."}
                                  showLoadingBar={this.state.showLoadingBar}/>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/exercise/ExerciseNewMultiple.js